<template>
  <div class="d-flex justify-content-center w-100" style="margin: 100px 0" v-if="load">
    <Loading />
  </div>
  <div v-else class="w-100">
    <div class="w-100">
      <fieldset-component
        texto="Información relevante a la ruta"
        bold
        class="mb-3"
      />

      <div class="px-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <!-- Año -->
          <ui-select
            class="w-50"
            has-search
            label="Año (*)"
            placeholder="Seleccionar"
            v-if="booking.year.show"
            :disabled="editAnio"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataAnios"
            v-model="booking.year.value"
          />

          <!-- Semana -->
          <ui-select
            class="w-50 ml-3"
            has-search
            label="Semana (*)"
            placeholder="Seleccionar"
            v-if="booking.week.show"
            searchPlaceholder="Buscar"
            :disabled="editSemana"
            :keys="{ value: 'id', label: 'name' }"
            :options="allYearWeeks ? dataSemanasAnio : dataSemanas"
            v-model="booking.week.value"
          />

          <!-- Empresa -->
          <ui-textbox
            v-if="!isAdmin"
            class="w-50 ml-3"
            floating-label
            label="Empresa (*)"
            v-model="booking.id_client.value.name"
            :disabled="booking.id_client.disabled === undefined"
          />

          <ui-select
            v-else
            class="w-50 ml-3"
            has-search
            label="Empresas  (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="[{ id: 0, name: ''}]"
            v-model="booking.id_client.value"
            
            error="Este campo es obligatorio."
          />
        </div>

        <!-- Fila 2 -->
        <div class="d-flex mt-3">
          <ui-select
            class="w-50"
            v-if="booking.port_load_id.show"
            has-search
            label="Puerto de embarque POL (*)"
            @change="changePortOrigin()"
            placeholder="Seleccionar"
            v-model="booking.port_load_id.value"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            error="Este campo es obligatorio."
          />

          <ui-select
            class="w-50 ml-3"
            v-if="booking.port_origin_id.show"
            has-search
            label="Lugar de origen  (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            v-model="booking.port_origin_id.value"
            @change="informacionDeRuta()"
            error="Este campo es obligatorio."
          />

          <ui-select
            class="w-50 ml-3"
            v-if="booking.port_discharge_id.show"
            has-search
            label="Puerto de descarga - POD (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="booking.port_discharge_id.value"
            :options="dataPuertoDescarga"
            @change="informacionDeRuta()"
            error="Este campo es obligatorio."
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex mt-3">
          <ui-select
            class="w-50"
            v-if="booking.port_destination_id.show"
            has-search
            label="Lugar de destino final  (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            v-model="booking.port_destination_id.value"
            @change="informacionDeRuta()"
            error="Este campo es obligatorio."
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Nave (*)"
            v-if="booking.vessel.show"
            v-model="booking.vessel.value"
            error="Este campo es obligatorio."
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Viaje (*)"
            type="text"
            v-if="booking.voyage.show"
            v-model="booking.voyage.value"
            error="Este campo es obligatorio."
          />
        </div>

        <!-- Fila 4 -->
        <div class="d-flex align-items-center justify-content-between w-100 mt-2">
          <!-- v-if="usuarioActual.id_country != 64" -->
          <div class="d-flex align-items-center justify-content-between w-100">
            <ui-switch
              @change="showTransporteTerrestre()"
              v-model="transporteTerrestreModel"
              v-if="booking.haulage_carrier_id.show"
              >¿Transporte terrestre?</ui-switch
            >

            <Button
              :size="17"
              :width="170"
              :height="30"
              text="Seleccionar Nave y Viaje"
              color="#0174f3"
              colorText="#ffffff"
              icon="fas fa-ship"
              tooltip="Seleccionar Nave y Viaje"
              horizontal
              @click.native="actionSetVisibleModalSeleccionNaveActualizar(true)"
            />
          </div>

          <seleccion-nave-modal-update
            :booking="booking"
            :year="booking.year.value"
            :week="booking.week.value"
            :pod="booking.port_discharge_id.value"
            :type="booking.container_id.value.id"
          />
        </div>
      </div>
    </div>

    <div class="mt-4">
      <fieldset-component texto="Información de camionaje" bold class="mb-3" />

      <div class="w-100">
        <!-- Fila -->
        <div class="d-flex px-4">
          <ui-textbox
            v-if="booking.haulage_movement_type.show"
            class="w-50"
            floating-label
            label="Tipo movimiento"
            disabled
            v-model="booking.haulage_movement_type.value"
            error="Este campo es obligatorio."
          />
          <ui-textbox
            v-if="booking.haulage_cost.show"
            class="w-50 ml-3"
            floating-label
            label="Costo camionaje"
            disabled
            v-model="booking.haulage_cost.value"
            error="Este campo es obligatorio."
          />
          <ui-textbox
            v-if="booking.haulage_transport_type.show"
            class="w-50 ml-3"
            floating-label
            label="Tipo de Transporte"
            disabled
            v-model="booking.haulage_transport_type.value"
            error="Este campo es obligatorio."
          />
        </div>

        <div
          class="d-flex px-4"
          v-if="transporteTerrestreModel "
        >
          <ui-select
            class="w-50"
            has-search
            label="Lugar de carga"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            v-model="booking.haulage_port_origin_id.value"
          />

          <div class="d-flex flex-column w-50">
            <label class="content-datepicker">Fecha retiro unidad</label>

            <date-picker
              format="YYYY-MM-DD"
              type="date"
              v-model="booking.haulage_withdrawal_date.value"
            ></date-picker>
          </div>

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Tipo chasis (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataTipoChasis"
            v-model="booking.haulage_rampla.value"
          />
        </div>

        <!-- Fila 3 -->
        <div
          class="d-flex px-4"
          v-if="transporteTerrestreModel"
        >
          <ui-select
            class="w-50"
            has-search
            label="Packing"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaPackingAux"
            v-model="booking.haulage_packing_id.value"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Dirección packing"
            v-model="booking.haulage_carrier.value"
            disabled
          />

          <!-- <ui-select
            v-if="booking.haulage_transport_type.value == 'MH Mercahnt Haulage'"
            class="w-50 ml-2"
            has-search
            label="Transportista"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :options="listaTransportista"
            :keys="{ value: 'id', label: 'name' }"
          /> -->
        </div>
      </div>
    </div>

    <div class="w-100" v-if="showModuleServicioIntegral">
      <fieldset-component
        texto="Información de Servicio Integral"
        bold
        class="mb-3 mt-4"
      />

      <div class="d-flex px-4">
        <ui-select
          class="w-50"
          has-search
          label="¿Servicio Integral? (*)"
          v-if="booking.has_si.show"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :options="['Si', 'No']"
          v-model="booking.has_si.value"
          @change="showServicioIntegral()"
        />

        <ui-select
          v-if="servicioIntegral"
          class="w-50 ml-3"
          has-search
          label="Tipo Servicio Integral (*)"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="dataserviciosIntegrales"
          v-model="booking.si_type_id.value"
        />
      </div>
    </div>

    <!-- Información relevante a shipper -->
    <div>
      <fieldset-component
        texto="Información relevante a shipper"
        bold
        class="mb-3 mt-4"
      />

      <div class="px-4">
        <div class="d-flex">
          <ui-select
            class="w-50"
            @change="
              obtenerDireccionesPorShipper(booking.shipper.value.id);
              obtenerConsignatariosYNotificadosData(true);
              setSelectAndOptionsEmbarcador() ;
            "
            has-search
            label="Shipper (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            v-if="booking.shipper.show"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaShippersAux"
            v-model="booking.shipper.value"
            error="Este campo es obligatorio."
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Dirección shipper  (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            ref="selectDireccionesShippers"
            :keys="{ value: 'id', label: 'name' }"
            v-model="booking.shipper_address_id.value"
            v-if="booking.shipper_address_id.show"
            :options="listarDireccionesShippers"
            error="Este campo es obligatorio."
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Consignatario (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            ref="selectListarConsignatarios"
            :keys="{ value: 'id', label: 'name' }"
            :options="listarConsignatarios"
            v-model="booking.shipper_consignee_id.value"
            v-if="booking.shipper_consignee_id.show"
            error="Este campo es obligatorio."
          />
        </div>

        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Notificado (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            ref="selectListarNotificados"
            :keys="{ value: 'id', label: 'name' }"
            v-model="booking.shipper_notify_id.value"
            v-if="booking.shipper_notify_id.show"
            :options="listarNotificados"
            error="Este campo es obligatorio."
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Embarcador"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="shippers"
            v-model="booking.shipper_id.value"
          />
        </div>
      </div>
    </div>

    <!-- Información relevante a la carga -->
    <div>
      <fieldset-component
        texto="Información relevante a la carga"
        bold
        class="mb-3 mt-4"
      />

      <div class="px-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Contenedor a solicitar (*)"
            placeholder="Seleccionar"
            v-model="booking.container_id.value"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataContenedores"
            @change="isReeferValidate"
          />
   
          <ui-select
            class="w-50 ml-3"
            has-search
            label="Producto a exportar (*)"
            placeholder="Seleccionar"
            v-model="booking.id_client_product.value"
            searchPlaceholder="Buscar"
            v-if="booking.id_client_product.show"
            :keys="{ value: 'id', label: 'name' }"
            :options="productosPorCliente"
            @change="
              obtenerContratos();
              obtenerRefigeracionProductoSeleccionado(booking.id_client_product.value.id);
            "
            

            error="Este campo es obligatorio."
          />

          <ui-textbox
            v-model="booking.containers_requested.value"
            class="w-50 ml-3"
            floating-label
            v-if="booking.containers_requested.show"
            label="Cantidad de contenedores a solicitar (*)"
            type="number"
            error="Este campo es obligatorio."
          />

          <ui-textbox
            v-model="booking.cantidad_bi.value.name"
            v-if="
              booking.cantidad_bi.show && booking.cantidad_bi.show != undefined
            "
            booking.cantidad_bi.show
            class="w-50 ml-3"
            floating-label
            else="booking.cantidad_bi.show"
            label="Cant. de contenedores"
            type="number"
            :min="1"
            :max="99"
            error="Este campo es obligatorio."
          />

          <ui-textbox
            v-model="booking.embarked_containers.value"
            v-if="booking.embarked_containers.show"
            class="w-50 ml-3"
            floating-label
            type="number"
            else="booking.embarked_containers.show"
            label="Cantidad de contenedores embarcados (*)"
            error="Este campo es obligatorio."
          />
        </div>

        <!-- Fila 2 -->
        <div class="d-flex" v-if="isReefer">
          <ui-textbox
            class="w-50"
            floating-label
            label="Temperatura °C (*)"
            @blur="clearCharactersTemperature()"
            v-model="booking.container_temperature.value"
            v-if="booking.container_temperature.show"
          />

          <ui-textbox
            v-if="booking.container_percent_ventilation.show"
            v-model="booking.container_percent_ventilation.value"
            class="w-50 ml-3"
            floating-label
            type="number"
            label="% Ventilación (*)"
          />

          <ui-textbox
            v-model="booking.container_cbm_ventilation.value"
            class="w-50 ml-3"
            floating-label
            label="Ventilación CBM (*)"
            type="number"
            v-if="booking.container_cbm_ventilation.show"
          />

          <ui-select
            class="w-50 ml-3"
            v-model="booking.container_cold_treatment.value"
            has-search
            label="Con Cold Treatment (*)"
            placeholder="Seleccionar"
            v-if="booking.container_cold_treatment.show"
            searchPlaceholder="Buscar"
            :options="['Si', 'No']"
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex" v-if="isAtmosphera">
          <ui-select
            class="w-50"
            v-if="booking.container_atmosphere_id.show"
            has-search
            label="Atmósfera controlada (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaAtmosferas"
            v-model="booking.container_atmosphere_id.value"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="% Oxígeno (O2) (*)"
            v-if="booking.container_percent_o2.show"
            v-model="booking.container_percent_o2.value"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="% CO2 (*)"
            v-model="booking.container_percent_co2.value"
            v-if="booking.container_percent_co2.show"
          />

          <div class="w-50 ml-3"></div>
        </div>

        <div class="d-flex">
          <ui-textbox
            v-model="booking.nro_booking"
            v-if="editNroBooking"
            class="w-50 ml-3"
            floating-label
            label="Nro Booking"
            error="Este campo es obligatorio."
          />
          <ui-textbox
            v-model="booking.carrier_booking_number"
            v-if="editNroBooking"
            class="w-50 ml-3"
            floating-label
            label="Nro Carrier Booking"
            error="Este campo es obligatorio."
          />
        </div>

        <div class="d-flex">
          <ui-select
            class="w-50 ml-3"
            v-if="editNroBooking"
            v-model="booking.deposito"
            has-search
            label="Depósito"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar Depositos"
            :keys="{ value: 'id', label: 'name' }"
            :options="depositos"
          />
          <ui-select
            class="w-50 ml-3"
            v-if="editNroBooking"
            v-model="booking.via"
            has-search
            label="vía"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar vía"
            :keys="{ value: 'id', label: 'name' }"
            :options="vias"
          />
          <ui-select
            class="w-50 ml-3"
            v-if="editNroBooking"
            v-model="booking.naviera_salida"
            has-search
            label="Naviera de salida"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar Naviera"
            :keys="{ value: 'id', label: 'name' }"
            :options="navieras"
          />
        </div>

        
      </div>
    </div>

    <!-- Información adicional-->
    <div>
      <fieldset-component
        texto="Información adicional"
        bold
        class="mb-3 mt-4"
      />

      <div class="px-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Forma de pago (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="booking.payment_method.value"
            :options="listaMetodosPagos"
            v-if="booking.payment_method.show"
            error="Este campo es obligatorio."
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Uso de genset de la naviera"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :options="['Si', 'No']"
            v-model="booking.genset.value"
            v-if="booking.genset.show"
            error="Este campo es obligatorio."
          />
        </div>

        <!-- Fila 2 -->
        <div class="d-flex">
          <ui-textbox
            class="w-50"
            v-if="booking.emition_bl.show"
            floating-label
            label="Emisión de BL (*)"
            v-model="booking.emition_bl.value"
            error="Este campo es obligatorio."
          />

        <!-- xx -->
          <ui-select
            class="w-50 ml-3"
            has-search
            label="Contrato (*)"
            v-if="booking.contract.show"
            v-model="booking.contract.value"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :options=" listarContratosOptions"
            :keys="{ value: 'id', label: 'name' }"
            error="Este campo es obligatorio."
            @change="mostrarNroContrato(booking.contract.value)"
          />
        </div>

        <!-- Fila 2.1 -->
        <div class="d-flex">
          <ui-textbox
            class="w-100"
            floating-label
            label="Nro. Contrato (*)"
            v-model="booking.contrato_booking.value"
            v-if="isContratoBooking"
            title="Nro. de Contrato ingresado se utilizará en la generación de los respectivos bs/l. UCC no será responsable por el mal ingreso de ésta información."
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex">
          <ui-textbox
            class="w-100"
            v-model="booking.comment.value"
            floating-label
            v-if="booking.comment.show"
            label="Comentarios"
            multiLine
            style="min-height: 115px !important"
            :rows="5"
            error="Supera máximo de carácteres."
            :maxlength="256"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapState, mapActions } from "vuex";
  import UiTextbox from "keen-ui/lib/UiTextbox";
  import UiSwitch from "keen-ui/lib/UiSwitch";
  import UiSelect from "keen-ui/lib/UiSelect";

  import FieldsetComponent from "../../../components/common/FieldsetComponent";
  import Button from "../../../components/common/Button";
  import SeleccionNaveModalUpdate from "../../modals/lineas/booking/SeleccionNaveModalUpdate";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/locale/es";
  import "vue2-datepicker/index.css";

  import {
    getBookingsNoPlanificadosSinLoading,
    obtenerShippers,
    obtenerDireccionesPorShipper,
    obtenerProductosPorCliente,
    obtenerTransportistaPorCliente,
    obtenerConsignatariosYNotificados,
    obtenerContrato,
    getSelectAndOptionsEmbarcador,
    getDepositosViasNavieras,
    obtenerRefigeracionProducto
  } from "../../../constants/lineas";

  import Loading from "../loading.vue";

  export default {
    props: {
      booking: Object,
      load: Boolean,
      editNroBooking: { type: Boolean, default: false },
      showModuleServicioIntegral: { type: Boolean, default: true },
      showDataTransporteTerrestreModel: { type: Boolean, default: false },
      editSemana: { type: Boolean, default: true },
      allYearWeeks: { type: Boolean, default: false },
      editAnio: { type: Boolean, default: true },
    },

    data() {
      return {
        isAdmin: false,
        transporteTerrestreModel: false,
        tipoTransporteModel: "",
        isReefer: false,
        dataAnios: [{ id: 0, name: ''}],
        dataSemanas: [{ id: 0, name: ''}],
        dataSemanasAnio: [{ id: 0, name: ''}],
        clienteModel: [{ id: 0, name: ''}],
        listaClientesUsuarioActual: [{ id: 0, name: ''}],
        dataPuertoDescarga: [{ id: 0, name: ''}],
        dataserviciosIntegrales: [{ id: 0, name: ''}],
        listaShippersAux: [{ id: 0, name: ''}],
        listarDireccionesShippers: [{ id: 0, name: ''}],
        listarConsignatarios: [{ id: 0, name: ''}],
        listarNotificados: [{ id: 0, name: ''}],
        dataContenedores: [{ id: 0, name: ''}],
        productosPorCliente: [{ id: 0, name: ''}],
        listaMetodosPagos: [{ id: 0, name: ''}],
        listaAtmosferas: [{ id: 0, name: ''}],
        servicioIntegral: false,
        isAtmosphera: false,
        listarContratosOptions: [{ id : 0, name : "Otro" }],
        dataTipoChasis: [
          { id: 1, name: "Normal" },
          { id: 2, name: "3 Ejes" },
        ],
        listaPackingAux: [{ id: 0, name: ''}],
        listaTransportista: [{ id: 0, name: ''}],
        from_date: "",
        to_date: "",
        vias: [{ id: 0, name: ''}],
        depositos: [{ id: 0, name: ''}],
        navieras: [{ id: 0, name: ''}],
        naveModel        : "",
        viajeModel       : "",
        cargaModel       : "",
        naviera          : "",
        itineraryIdModel : "",
        isContratoBooking : false,
        //validators

        shippers:[{ id: 0, name: ''}],
      };
    },

    computed: {
      ...mapState("lineas", ["dataNaveSeleccionada"]),
    },

    methods: {
      ...mapActions("lineas", ["actionSetVisibleModalSeleccionNaveActualizar"]),
      
      changePortOrigin() {
        this.booking.port_origin_id.value = this.booking.port_load_id.value;
        this.informacionDeRuta();
      },
      
      informacionDeRuta() {
        if (
          !this.booking.port_load_id.value ||
          !this.booking.port_origin_id.value ||
          !this.booking.port_discharge_id.value ||
          !this.booking.port_destination_id.value
        ) {
          return;
        }

        // cost y type sólo varian cuando el movementType = CY/CY, por lo cual se dejan
        // setteados con opciones por defectos para los casos restantes.
        this.booking.haulage_cost.value = "Naviera";
        this.booking.haulage_transport_type.value = "CH Carrier Haulage";

        // CY/CY
        if (
          this.booking.port_origin_id.value.name ==
            this.booking.port_load_id.value.name &&
          this.booking.port_discharge_id.value.name ==
            this.booking.port_destination_id.value.name
        ) {
          // Información guardada en modelos
          this.booking.haulage_movement_type.value = "CY/CY";
          this.booking.haulage_cost.value = "Cliente";
          this.booking.haulage_transport_type.value = "MH Mercahnt Haulage";
        } else if (
          // Door to Port
          this.booking.port_origin_id.value.name !=
            this.booking.port_load_id.value.name &&
          this.booking.port_discharge_id.value.name ==
            this.booking.port_destination_id.value.name
        ) {
          // Información guardada en modelos
          this.booking.haulage_movement_type.value = "Door to Port";
        } else if (
          // Port To Door
          this.booking.port_origin_id.value.name ==
            this.booking.port_load_id.value.name &&
          this.booking.port_discharge_id.value.name !=
            this.booking.port_destination_id.value.name
        ) {
          // Información guardada en modelos
          this.booking.haulage_movement_type.value = "Port To Door";
        } else if (
          // Door To Door
          this.booking.port_origin_id.value.name !=
            this.booking.port_load_id.value.name &&
          this.booking.port_discharge_id.value.name !=
            this.booking.port_destination_id.value.name
        ) {
          // Información guardada en modelos
          this.booking.haulage_movement_type.value = "Door To Door";
        }
      },

      showTransporteTerrestre() {
        //this.transporteTerrestreModel = this.transporteTerrestreModel;
      },

      isReeferValidate(data) {
        this.isAtmosphera = data.with_ac === 1 ? true : false;
        this.isReefer = data.with_frozen === 1 ? true : false;
      },

      async obtenerProductosPorCliente(id_client) {
        this.productosPorCliente = await obtenerProductosPorCliente(id_client);
      },

      async changeShipper(id_client) {
        this.listaShippersAux = await obtenerShippers(id_client);
      },

      async obtenerDireccionesPorShipper(id_client) {
        this.listarDireccionesShippers = await obtenerDireccionesPorShipper(
          id_client
        );
      },
      async setSelectAndOptionsEmbarcador(){

        if( this.booking.shipper.value.id !== undefined ){
          const { data } = await getSelectAndOptionsEmbarcador( this.booking.shipper.value.id ) ;
          
          if( data.options !== null ){
            this.booking.shipper_id.value = data.options ;
          }
        }
      },
      async getdata() {

        const {
          filtroAnios,
          filtroSemanas,
          filtroSemanasAnio,
          filtro_puertos,
          listaServiciosIntegrales,
          filtro_contenedores,
          filtroMetodosPago,
          listaAtmosferas,
          listaPackingAux,
          shippers
        } = await getBookingsNoPlanificadosSinLoading();

        this.dataAnios                = filtroAnios;
        this.dataSemanasAnio          = filtroSemanasAnio;
        this.dataSemanas              = filtroSemanas;
        this.dataPuertoDescarga       = filtro_puertos;
        this.dataserviciosIntegrales  = listaServiciosIntegrales;
        this.dataContenedores         = filtro_contenedores ;
        this.listaMetodosPagos        = filtroMetodosPago;
        this.listaAtmosferas          = listaAtmosferas;
        this.listaPackingAux          = listaPackingAux;
        this.shippers                 = shippers;
      },

      showServicioIntegral() {
        this.servicioIntegral = this.booking.has_si.value === "Si" ? true : false;
      },

      async obtenerTransportistaPorCliente(id) {
        const data = await obtenerTransportistaPorCliente(id);
        this.listaTransportista = data;
      },

      async obtenerConsignatariosYNotificadosData(clear = false) {

        const { data } = await obtenerConsignatariosYNotificados(
          this.booking.shipper.value.id
        );

        const { consignatarios, notificados } = data;
        this.listarConsignatarios =
          consignatarios === undefined ? [] : consignatarios;
        this.listarNotificados = notificados === undefined ? [] : notificados;

        if (clear) {
          this.booking.shipper_notify_id.value = {};
          this.booking.shipper_consignee_id.value = {};
          this.booking.shipper_address_id.value = {};
        }
      },

      mostrarNroContrato(estado){

        if (estado.name == 'Otro') {
          this.isContratoBooking = true;
        }else{
          this.isContratoBooking = false;
        }

      },

      async obtenerContratos(){
        
        if (
          
          this.booking.port_load_id.value.id != '' &&
          this.booking.port_destination_id.value.id != '' &&
          this.booking.id_client_product.value.id_product_type != '' &&
          this.booking.container_id.value != '' &&
          this.booking.week.value != ''
        ){
          let data = {
            pol                   : parseInt(this.booking.port_load_id.value.id),
            pod                   : parseInt(this.booking.port_destination_id.value.id),
            naviera_id            : parseInt(this.booking.itineraries.naviera_id),
            products_category_id  : parseInt(this.booking.id_client_product.value.id_product_type),
            container_id          : parseInt(this.booking.container_id.value.id),
            client_id             : parseInt(this.booking.id_client.value.id),
            atmosphere_id         : this.booking.container_atmosphere_id.value.id == 0 ? "" : this.booking.container_atmosphere_id.value.id,
            from_date             : this.booking.pol_etd.value
          };

          let sql = await obtenerContrato(data);

          let dataSelectContratos = [];

          if (sql.length > 0) {

            sql.map(item => {
              dataSelectContratos.push({id: item.tariff_contract_id , name: item.contrato});
            });

            this.listarContratosOptions = [];
            this.listarContratosOptions = dataSelectContratos;
            this.listarContratosOptions.push({id: 0, name: "Otro"});
            this.isContract             = true;

          } else {

            this.listarContratosOptions = [{id: 0, name: "Otro"}];
            this.booking.contract.value = this.listarContratosOptions[0];
            this.isContract             = false;

            this.$vToastify.warning("Esta ruta no posee contrato, por favor contacte al administrador o ingrese su propio número de contrato.","!Precaución¡");

          }

        }
      },

      clearCharactersTemperature(){

        let value = this.booking.container_temperature.value + "" ;

        const reg = /[a-z]|[A-Z]/g ;

        value = value.trim() ;
        value = value.replaceAll( reg , "") ;
        value = value.replaceAll(',' , '.') ;

        const lastCharNoPermitidos = ['+','-',',','.'] ;
        const firstCharNoPermitidos = ['+',',','.'] ;

        let firstchar = value.charAt(0) ;
        let lastchar = value.charAt(value.length - 1) ;

        if( firstCharNoPermitidos.includes( firstchar ) ) value = value.slice(1) ;

        if( lastCharNoPermitidos.includes( lastchar ) ) value = value.slice(0,-1) ;

        this.booking.container_temperature.value = value ;
      },
      async obtenerRefigeracionProductoSeleccionado(id_producto) {

        const data = await obtenerRefigeracionProducto(id_producto);

        if ( data.length > 0) {
          this.booking.container_temperature.value         = data[0].temp ;
          this.booking.container_percent_ventilation.value = data[0].vent;
          this.booking.container_cbm_ventilation.value     = data[0].vent_cbm;
        }
      },
    },

    components: {
      FieldsetComponent,
      UiTextbox,
      UiSwitch,
      UiSelect,
      Button,
      SeleccionNaveModalUpdate,
      Loading,
      DatePicker,
    },

    async created(){
      const { data, status } = await getDepositosViasNavieras();
      if( status === 200 ){
        this.depositos = data.deposits.map( ({ id, name }) => ({ id, name }));
        this.vias = data.vias.map( ({ id, name }) => ({ id, name }));
        this.navieras = data.navieras.map( ({ id, name }) => ({ id, name }));
      }
    },

    watch: {
      load: function (loading) {
        if(!loading){
          
          this.isReeferValidate({
            id: this.booking.container_id.value.id,
            name: this.booking.container_id.value.name,
            type: this.booking.container_id.value.type,
            with_ac: this.booking.with_ac.value ? 1 : 0,
            with_frozen: this.booking.with_frozen.value ? 1 : 0,
          });
        }
      },

      booking: async function (_new) {

        if (_new) {
          if( this.booking.contrato_booking !== undefined ){
            if( !this.booking.contract.value.id ){
              this.booking.contract.value = [];
              this.booking.contract.value = {id: 0, name : 'Otro'};
              
              if( this.booking.contract_number.value !== undefined ){
                this.booking.contrato_booking.value = this.booking.contract_number.value ;
              }

              this.isContratoBooking = true;

            }else{

              this.isContratoBooking = false;

            }
          }

          this.isReeferValidate({
            id: this.booking.container_id.value.id,
            name: this.booking.container_id.value.name,
            type: this.booking.container_id.value.type,
            with_ac: this.booking.with_ac.value ? 1 : 0,
            with_frozen: this.booking.with_frozen.value ? 1 : 0,
          });
          
          this.obtenerConsignatariosYNotificadosData();
          await this.getdata();

          this.changeShipper(_new.id_client.value.id);

          this.obtenerDireccionesPorShipper(_new.shipper.value.id);

          this.obtenerProductosPorCliente(_new.id_client.value.id);

          // this.isReefer = _new.type_container.value === "Reefer" ? true : false;

          // this.isAtmosphera = _new.with_ac.value;

          // //nuevo campo
          this.transporteTerrestreModel = _new.haulage_carrier_id.value.id !== undefined && _new.haulage_carrier_id.value.id !== "" ;
          this.showServicioIntegral();
          this.informacionDeRuta();
          this.obtenerTransportistaPorCliente(_new.id_client.value.id);

          setTimeout(() => {
              // Obtener contratos
            this.obtenerContratos();
          }, 2000);

        }
      },

      dataNaveSeleccionada: function (_new) {

        if (_new) {
          this.booking.vessel.value           = _new.nave;
          this.booking.voyage.value           = _new.viaje;
          this.booking.port_load_id.value     = _new.pol;
          this.booking.itineraries.naviera_id = _new.naviera.id;
          this.booking.pol_etd.value          = _new.from_date;

          this.obtenerContratos();
        }
      },
    },
  };

</script>
